import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './components/Login';

// Lazy load page components
const Dashboard = lazy(() => import('./pages/Dashboard'));
const PropsModule = lazy(() => import('./pages/props'));
const PhotographyModule = lazy(() => import('./pages/photography'));
const BillingModule = lazy(() => import('./pages/billing'));
const ExpensesModule = lazy(() => import('./pages/expenses'));
const InvestmentsModule = lazy(() => import('./pages/investments'));
const StaffModule = lazy(() => import('./pages/staff'));

// Loading component
const PageLoader = () => (
  <div className="flex items-center justify-center min-h-screen">
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#FD5D86]"></div>
  </div>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Layout>
                    <Dashboard />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/props/*"
              element={
                <ProtectedRoute requiredModule="props">
                  <Layout>
                    <PropsModule />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/photography/*"
              element={
                <ProtectedRoute requiredModule="photography">
                  <Layout>
                    <PhotographyModule />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/billing/*"
              element={
                <ProtectedRoute requiredModule="billing">
                  <Layout>
                    <BillingModule />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/expenses/*"
              element={
                <ProtectedRoute requiredModule="expenses">
                  <Layout>
                    <ExpensesModule />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/investments/*"
              element={
                <ProtectedRoute requiredModule="investments">
                  <Layout>
                    <InvestmentsModule />
                  </Layout>
                </ProtectedRoute>
              }
            />
            <Route
              path="/staff/*"
              element={
                <ProtectedRoute requiredModule="staff">
                  <Layout>
                    <StaffModule />
                  </Layout>
                </ProtectedRoute>
              }
            />
          </Routes>
        </Suspense>
      </AuthProvider>
    </Router>
  );
}

export default App;
